import React from 'react';

import color, { ThemeColorString } from '@lib/utils/color';

import Stack, { StackProps } from '@components/Stack';

interface DividerProps extends StackProps {
    colorString?: ThemeColorString;
    width?: number;
}

const Divider: React.FC<DividerProps> = ({ colorString = 'border', width = 1, ...props }) => {
    const borderColor = color(colorString);
    return (
        <Stack
            style={{
                borderWidth: 0,
                borderTopWidth: width,
                borderColor
            }}
            {...props}
        />
    );
};

export default Divider;
